var exports = {
  "kL": "x127c5a35--4d7552--container",
  "wx": "x127c5a35--4d7552--header",
  "W1": "x127c5a35--4d7552--input-link",
};

module.exports = exports;
